import React, { useState } from "react";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";

const SimpleImageCarousel = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [hover, setHover] = useState(false); // ⭐ REQUIRED

  const nextImage = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  return (
    <div
      className="simple-carousel"
      style={{
        position: "relative", // ⭐ IMPORTANT for button positioning
        width: "100%",
        maxWidth: "100%",
      }}
    >
      <img
        src={images[currentIndex]}
        alt={`Slide ${currentIndex + 1}`}
        style={{
          width: "100%",
          borderRadius: "8px",
          display: "block",
        }}
      />

      <button
        onClick={nextImage}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        style={{
          position: "absolute",
          right: "0px",
          top: "50%",
          transform: "translateY(-50%)",
          background: hover ? "rgba(0,0,0,0.6)" : "rgba(0,0,0,0.35)",
          border: "none",
          borderRadius: "12px",
          width: "60px",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "40px",
          color: "white",
          cursor: "pointer",
          transition: "all 0.25s ease",
        }}
      >
        <MdOutlineKeyboardArrowRight />
      </button>
    </div>
  );
};

export default SimpleImageCarousel;
